module.exports = "<my-vacations user-inception-id=\"$ctrl.userInceptionId\"></my-vacations>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendar/managerAsEmployeeCalendar.html
// module id = 1331
// module chunks = 0